(function(){"use strict";

/* --- CRITICAL CSS INJECTION (fixes mobile opacity bug) --- */
(function injectCriticalCSS() {
  var s = document.createElement('style');
  s.textContent = ''
    + '.report.visible { opacity: 1 !important; visibility: visible !important; transform: translateY(0) !important; transition: none !important; }'
    + '#loader.done, .loading-screen.done { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; display: none !important; }'
    + '.report.visible .reveal { opacity: 1 !important; transform: translateY(0) !important; visibility: visible !important; }';
  document.head.appendChild(s);
})();

/* ============================================================
   BRAND BLIND SPOT REPORT v3 - PERSONALIZATION ENGINE
   ES5-compatible for Shopify CDN minification
   Reads quiz data from URL params, renders personalized report
   Stolan Acres (c) 2026
   ============================================================ */

// ---- ARCHETYPE DATA ----
var ARCHETYPES = {
  MESSAGE: {
    name: "The Invisible Expert",
    tagline: "You're great at what you do. Nobody knows.",
    callout: function(n) {
      return '<span class="section-label">Section 2 - Your Blind Spot Decoded</span>'
        + '<h3>' + n + ', Your Work Speaks for Itself - When People See It.</h3>'
        + '<p>You\u2019ve got the skills. You\u2019ve put in the reps. The quality of what you deliver is undeniable - to the people who actually experience it. But here\u2019s the problem: <strong>almost nobody experiences it.</strong></p>'
        + '<p>The way you talk about what you do doesn\u2019t match the level of what you actually deliver. You\u2019re not losing to people who are better than you. You\u2019re losing to people who can <strong>explain themselves in one sentence.</strong></p>'
        + '<p>That sentence is doing more work than your entire portfolio. Your MESSAGE dimension scored lowest - which means the gap between your talent and your ability to communicate it is where the leak is.</p>'
        + '<p>This isn\u2019t a skills problem, ' + n + '. It\u2019s a translation problem. You speak fluent expertise. Your audience needs fluent outcomes.</p>';
    },
    cost: '<span class="section-label" style="color:var(-sred-soft)">Section 3 - What This Is Costing You</span>'
      + '<h3>The Invisible Tax on Your Expertise</h3>'
      + '<p>Every conversation where someone says "so what do you do?" and you stumble - that\u2019s a client who walks. Every bio that reads like a job description instead of a magnet - that\u2019s traffic that bounces.</p>'
      + '<p><strong>Here\u2019s what\u2019s actually happening:</strong> You\u2019re sitting on a goldmine of talent with a handwritten sign out front. The people who need you most can\u2019t find you. The ones who do can\u2019t figure out why they should care. And every day this continues, someone with half your skill but twice your clarity is closing the clients that should be yours.</p>'
      + '<p>The compound cost? <strong>Every month you stay invisible, your market trains itself to look elsewhere.</strong> The longer the silence, the harder it becomes to be heard when you finally speak up.</p>',
    shift: 'Stop explaining what you do. Start explaining what happens when you do it. Nobody buys the process - they buy the outcome. One clear sentence about the result you create is worth more than a paragraph about your methodology. The shift is simple: from "I do X" to "You get Y."',
    action: 'Open your phone. Go to the bio on whatever platform matters most. Delete everything. Write ONE sentence that answers: "What changes for the person who works with me?" That sentence is worth more than 100 posts about your process. Do it right now - before this tab closes.',
    roadmapSteps: [
      {label:"Step 1 - The Shift",title:"Rewrite Your Core Message",body:"Your one-sentence pitch needs to lead with transformation, not credentials. Take the action above - rewrite your bio around the outcome you create. This alone can double your DM response rate within a week.",locked:false},
      {label:"Step 2 - The System",title:"Build Your Message Architecture",body:"One bio isn\u2019t enough. You need a messaging system - a core message that flexes across platforms, DMs, proposals, and conversations without losing its power. The Reinvention OS walks you through building this from scratch.",locked:true},
      {label:"Step 3 - The Transformation",title:"Become the Obvious Choice",body:"When your message is dialed in, everything changes. People find you. They understand you instantly. They refer you with confidence. You stop competing on price and start competing on clarity. This is where the Invisible Expert becomes the Undeniable Authority.",locked:true}
    ]
  },
  SIGNAL: {
    name: "The Shape-Shifter",
    tagline: "Different everywhere. Trusted nowhere.",
    callout: function(n) {
      return '<span class="section-label">Section 2 - Your Blind Spot Decoded</span>'
        + '<h3>' + n + ', You\u2019ve Got Range - and It\u2019s Killing Your Brand.</h3>'
        + '<p>You\u2019re creative. You\u2019re versatile. You can do a lot of things well. And that\u2019s exactly the problem. Because when someone finds you on Instagram, then checks your website, then sees your LinkedIn - <strong>they meet three different people.</strong></p>'
        + '<p>It\u2019s not that any one version of you is wrong. It\u2019s that five versions of you is confusing. And confusion doesn\u2019t convert. Your SIGNAL dimension scored lowest - meaning your brand looks and feels different depending on where people find you.</p>'
        + '<p>Trust is built on repetition. When your audience can\u2019t predict what they\u2019ll get from you, they choose someone whose brand feels safer. You\u2019re not inconsistent because you lack discipline, ' + n + ' - you\u2019re inconsistent because <strong>nobody ever gave you a system to be consistent with.</strong></p>';
    },
    cost: '<span class="section-label" style="color:var(-sred-soft)">Section 3 - What This Is Costing You</span>'
      + '<h3>The Trust Tax on Your Inconsistency</h3>'
      + '<p>Every time someone lands on one of your platforms and gets a different message, a different vibe, a different visual identity - <strong>you lose their trust before they even talk to you.</strong></p>'
      + '<p>Here\u2019s the math: a potential client checks 3-4 touchpoints before making a decision. If even one of those touchpoints feels "off" from the others, their confidence drops by 40%. You\u2019re essentially undoing your own marketing with every mismatched profile.</p>'
      + '<p>Meanwhile, brands that look and sound the same everywhere? They feel reliable. Professional. Safe to buy from. <strong>The compound cost:</strong> every day your platforms don\u2019t match, you\u2019re training your market to trust someone else.</p>',
    shift: 'Pick ONE platform. Make it your anchor. Everything else mirrors it - same message, same visual energy, same positioning. You don\u2019t need to be everywhere. You need to be the same person everywhere you are.',
    action: 'Screenshot your profile on 3 different platforms right now. Put them side by side. If they don\u2019t look and sound like the same person - that\u2019s where you\u2019re bleeding trust. Pick the one that feels most like you and make everything else match it this week.',
    roadmapSteps: [
      {label:"Step 1 - The Shift",title:"Anchor Your Signal",body:"Pick your strongest platform - the one where you feel most authentic and get the best engagement. That\u2019s your anchor. Screenshot it. This is the standard everything else must match.",locked:false},
      {label:"Step 2 - The System",title:"Build Your Signal System",body:"Consistency isn\u2019t about being rigid. It\u2019s about having a system - brand voice, visual identity, and messaging pillars that flex across platforms without breaking. The Reinvention OS gives you this system.",locked:true},
      {label:"Step 3 - The Transformation",title:"Become Unmistakably You",body:"When your signal is locked in, people recognize you before they read your name. You stop being \u2018that person I follow somewhere\u2019 and become \u2018the person I trust with this.\u2019 Recognition compounds into revenue.",locked:true}
    ]
  },
  STANCE: {
    name: "The Discount Trap",
    tagline: "Expert-level work. Entry-level prices.",
    callout: function(n) {
      return '<span class="section-label">Section 2 - Your Blind Spot Decoded</span>'
        + '<h3>' + n + ', Your Work Is Premium. Your Packaging Isn\u2019t.</h3>'
        + '<p>You know you\u2019re good. You\u2019ve got the results, the reps, the reputation among people who\u2019ve actually worked with you. But every time the money conversation comes up, something shifts. <strong>You over-explain. You soften. You discount before anyone even asks.</strong></p>'
        + '<p>And the market reads that energy perfectly - they treat you exactly how you present yourself. Your STANCE dimension scored lowest, which means your pricing and positioning aren\u2019t reflecting the actual value of what you deliver.</p>'
        + '<p>The people winning in your space aren\u2019t more talented, ' + n + '. <strong>They stopped apologizing for their prices.</strong> They lead with results instead of explanations. They package their expertise like it\u2019s worth what it costs - because it is.</p>';
    },
    cost: '<span class="section-label" style="color:var(--red-soft)">Section 3 - What This Is Costing You</span>'
      + '<h3>The Revenue You\u2019re Leaving on the Table</h3>'
      + '<p>Every time you drop your price, you\u2019re not just losing money on that deal - <strong>you\u2019re training your entire market to expect less from you.</strong> You attract bargain hunters instead of believers. You resent the work because you know it was worth more.</p>'
      + '<p>And the worst part? The clients who would happily pay your real rate never find you, because your pricing signals "budget option" before your work ever gets a chance to speak. Premium clients don\u2019t shop on price - they shop on confidence. And your pricing is broadcasting uncertainty.</p>'
      + '<p><strong>The compound cost:</strong> every discounted project is a case study you can\u2019t use, a testimonial that undervalues you, and a referral that sends the wrong message about what you charge.</p>',
    shift: 'Stop justifying your price. Start proving your results. One client win, one specific number, one measurable outcome - that\u2019s worth more than a paragraph of explanation. Lead with proof, not permission.',
    action: 'Think of your best client result - the one that makes you proud. Write it as one sentence: "[Client] went from [before] to [after] in [timeframe]." Put that sentence in your bio, your proposals, and your DMs. That\u2019s your new price justification.',
    roadmapSteps: [
      {label:"Step 1 - The Shift",title:"Lead with Proof",body:"Write your best client transformation as one sentence. Put it in your bio, your proposals, and your DMs today. One proof point does more for your pricing power than any explanation ever will.",locked:false},
      {label:"Step 2 - The System",title:"Build Your Pricing Architecture",body:"Confidence isn\u2019t a feeling - it\u2019s a system. Your pricing needs to be anchored in positioning, packaged with intention, and communicated without apology. The Reinvention OS builds this architecture for you.",locked:true},
      {label:"Step 3 - The Transformation",title:"Become the Premium Choice",body:"When your stance is locked in, clients stop asking \u2018how much?\u2019 and start asking \u2018how soon?\u2019 You attract buyers who value quality over cost. The discount trap breaks permanently.",locked:true}
    ]
  },
  PATH: {
    name: "Famous Enough to Be Broke",
    tagline: "Everyone loves you. Nobody buys from you.",
    callout: function(n) {
      return '<span class="section-label">Section 2 - Your Blind Spot Decoded</span>'
        + '<h3>' + n + ', You\u2019ve Got the Audience. You\u2019re Missing the Bridge.</h3>'
        + '<p>People know you. They like your content. They engage with your posts. They tell you how "inspiring" you are. <strong>And then they buy from someone else.</strong></p>'
        + '<p>Because somewhere between the attention and the transaction, there\u2019s a gap you can\u2019t see - and it\u2019s costing you everything. Your PATH dimension scored lowest, meaning you have a conversion problem, not a visibility problem.</p>'
        + '<p>The attention is there, ' + n + '. The path from attention to income isn\u2019t. Meanwhile, people with half your following are making three times your revenue because they built <strong>a clear path from "I like this person" to "I\u2019m paying this person."</strong></p>';
    },
    cost: '<span class="section-label" style="color:var(--red-soft)">Section 3 - What This Is Costing You</span>'
      + '<h3>The Attention That Doesn\u2019t Pay Rent</h3>'
      + '<p>You\u2019re spending hours creating content, showing up, building an audience - and your bank account doesn\u2019t reflect any of it. The engagement feels good but <strong>it doesn\u2019t pay rent.</strong></p>'
      + '<p>Here\u2019s the painful truth: every "great post!" comment from someone who never buys is attention that leaked. Every DM that starts with "I love your work" and ends with ghosting is a conversion you lost because the path wasn\u2019t clear enough.</p>'
      + '<p><strong>The compound cost:</strong> the more visible you become without converting, the more your market sees you as "content" instead of "someone I should hire." You become famous enough to be recognized but not structured enough to be paid.</p>',
    shift: 'Every piece of content needs a next step. Not a hard sell - a clear path. "If this resonated, here\u2019s what to do next." Say it every time. The people who are ready will take the step. The ones who aren\u2019t will keep watching until they are.',
    action: 'Look at your last 5 posts or pieces of content. How many had a clear next step? Not "link in bio" - an actual invitation to go deeper. Add one to your next post: "If you\u2019re dealing with [problem], I built [thing] that fixes it. Link below." Track what happens.',
    roadmapSteps: [
      {label:"Step 1 - The Shift",title:"Add a Next Step to Everything",body:"Starting today, every piece of content gets a clear call to action. Not \u2018link in bio\u2019 - a specific invitation to take one step closer to working with you. This is the smallest change with the bigger revenue impact.",locked:false},
      {label:"Step 2 - The System",title:"Build Your Conversion Architecture",body:"A CTA on a post is a start. A conversion system is a machine. You need: a lead magnet, a nurture sequence, a clear offer path, and follow-up that doesn\u2019t feel salesy. The Reinvention OS builds all of this.",locked:true},
      {label:"Step 3 - The Transformation",title:"Turn Followers Into Revenue",body:"When your conversion path is built, everything changes. Posts become pipeline. Followers become customers. Your content stops being free entertainment and starts being the top of a revenue engine.",locked:true}
    ]
  },
  COMPOUND: {
    name: "The Spiral",
    tagline: "It\u2019s not one thing. It\u2019s a pattern.",
    callout: function(n) {
      return '<span class="section-label">Section 2 - Your Blind Spot Decoded</span>'
        + '<h3>' + n + ', Let\u2019s Be Real - It Feels Like Everything Is Broken.</h3>'
        + '<p>You can\u2019t explain what you do clearly. Your presence is scattered across platforms. You\u2019re undercharging. And the attention you do get doesn\u2019t turn into money. <strong>When everything feels broken, the instinct is to fix everything at once. That instinct is wrong</strong> - and it\u2019s the reason you feel stuck in a loop.</p>'
        + '<p>Your scores show weakness across multiple dimensions. The Spiral isn \u2019t about being bad at business, ' + n + '. It\u2019s about <strong>never having the foundation that makes everything else work.</strong> Without that foundation, every fix is temporary.</p>'
        + '<p>The good news? When you fix the foundation, everything else starts to realign. You don\u2019t need five separate fixes. You need one system.</p>';
    },
    cost: '<span class="section-label" style="color:var(--red-soft)">Section 3 - What This Is Costing You</span>'
      + '<h3>The Exhaustion of Fighting on Four Fronts</h3>'
      + '<p>You\u2019re spending energy on symptoms instead of the root cause. You try to fix your content, so you post more - but the message is unclear, so it doesn\u2019t connect. You try to fix your pricing, but your positioning doesn\u2019t justify it. You try to fix your conversions, but your brand signal is scattered.</p>'
      + '<p><strong>Each "fix" fails because it\u2019s disconnected from the others.</strong> The real cost isn\u2019t any one problem - it\u2019s the exhaustion of fighting on four fronts at once with no unified strategy.</p>'
      + '<p>And the hardest part? The longer you stay in the spiral, the harder it is to see the exit. Every failed attempt feels like proof that "maybe this just isn\u2019t for me." <strong>It is for you.</strong> You just need the right foundation.</p>',
    shift: 'Stop trying to fix everything. Fix your message first - one clear sentence about what you do and who it\u2019s for. Everything else (your pricing, your presence, your conversions) gets easier once people actually understand what you\u2019re offering. Start there. Only there.',
    action: 'Write this sentence and nothing else: "I help [specific person] go from [specific problem] to [specific result]." Don\u2019t overthink it. Don\u2019t make it clever. Just make it true. That\u2019s your starting point. Everything rebuilds from there.',
    roadmapSteps: [
      {label:"Step 1 - The Shift",title:"One Sentence. One Foundation.",body:"Write your core message: \u2018I help [who] go from [before] to [after].\u2019 This is not a branding exercise - it\u2019s the first brick of everything. Do it now, before you do anything else.",locked:false},
      {label:"Step 2 - The System",title:"Rebuild from the Foundation Up",body:"Once your message is clear, you layer on signal, stance, and path - in that order. The Reinvention OS is built specifically for founders in the Spiral: one system, one sequence, no guesswork.",locked:true},
      {label:"Step 3 - The Transformation",title:"Exit the Spiral Permanently",body:"When the foundation is solid, the spiral breaks. Your message attracts. Your signal builds trust. Your stance commands premium. Your path converts. For the first time, everything works together instead of against each other.",locked:true}
    ]
  }
};

// ---- DIMENSION LABELS ----
var DIM_LABELS = {
  MESSAGE: 'Message Clarity',
  SIGNAL: 'Brand Signal',
  STANCE: 'Pricing Power',
  PATH: 'Conversion Path'
};

// ---- NORMALIZE DEEP-DIVE PARAM VALUES ----
// Deep dive form sends human-readable labels; we map them to slug keys
var STAGE_MAP = {
  'Just starting': 'just-starting',
  'Side hustle': 'side-hustle',
  'Full-time but stuck': 'full-time-stuck',
  'Growing but stuck': 'growing-stuck',
  'Growing but chaotic': 'growing-chaotic',
  'Established, need refinement': 'established-refinement',
  'Established but invisible': 'established-invisible',
  'Rebuilding / pivoting': 'rebuilding'
};

var FRUSTRATION_MAP = {
  'Not enough clients': 'not-enough-clients',
  'Attracting wrong people': 'wrong-clients',
  "Can't charge what I'm worth": 'underpriced',
  'No clear direction': 'no-direction',
  'Content not converting': 'content-not-converting',
  "People don't understand what I do": 'cant-explain',
  'Attracting wrong clients': 'wrong-clients',
  'Underpriced for my value': 'underpriced',
  'Look like everyone else': 'look-generic',
  "Can't explain my difference": 'cant-differentiate'
};

var GOAL_MAP = {
  'Consistent income': 'consistent-income',
  'Quit my job': 'quit-job',
  'Premium clients': 'premium-clients',
  'Category authority': 'authority',
  'Brand freedom': 'freedom',
  'Full-time freedom': 'quit-job'
};

var TRIED_MAP = {
  'Visual rebrand': 'rebrand',
  'Posting more': 'content',
  'Course / coaching': 'coach',
  'Hired a coach': 'coach',
  'Lowered prices': 'lowered',
  'Changed offer': 'pivoted',
  'Pivoted offer': 'pivoted',
  'Nothing yet': 'nothing',
  'Paid ads': 'ads',
  'New website': 'website',
  'Hired a designer': 'designer'
};

function normalizeParam(val, map) {
  if (!val) return '';
  // Already a slug key? Check if it exists in the target data
  if (val.indexOf(' ') === -1 && val.indexOf('+') === -1) return val;
  // Decode URI and try map
  var decoded = decodeURIComponent(val).replace(/\+/g, ' ');
  return map[decoded] || val;
}

function normalizeTriedArray(arr) {
  if (!arr || arr.length === 0) return [];
  var out = [];
  for (var i = 0; i < arr.length; i++) {
    var decoded = decodeURIComponent(arr[i]).replace(/\+/g, ' ').trim();
    var mapped = TRIED_MAP[decoded] || decoded;
    if (mapped) out.push(mapped);
  }
  return out;
}

// ---- READ URL PARAMS (quiz + deep-dive) ----
function getParams() {
  var p = new URLSearchParams(window.location.search);
  var rawTried = p.get('tried') ? p.get('tried').split(',') : [];
  return {
    name: p.get('name') || 'Friend',
    score: parseInt(p.get('score')) || 42,
    m: parseInt(p.get('m')) || 50,
    s: parseInt(p.get('s')) || 50,
    st: parseInt(p.get('st')) || 50,
    path: parseInt(p.get('p')) || 50,
    type: p.get('type') || 'MESSAGE',
    stage: normalizeParam(p.get('stage') || '', STAGE_MAP),
    frustration: normalizeParam(p.get('frustration') || '', FRUSTRATION_MAP),
    goal: normalizeParam(p.get('goal') || '', GOAL_MAP),
    industry: p.get('industry') || '',
    tried: normalizeTriedArray(rawTried),
    email: p.get('email') || ''
  };
}

// ---- READ DEEP-DIVE DATA FROM LOCALSTORAGE ----
function getDeepDiveData() {
  var p = new URLSearchParams(window.location.search);
  var ls = null;
  try { var raw = localStorage.getItem('deepDiveData'); if (raw) ls = JSON.parse(raw); } catch(e) {}
  ls = ls || {};
  var data = {
    aboutYou: p.get('about') || ls.aboutYou || '',
    currentBio: p.get('bio') || ls.currentBio || '',
    linkUrl: p.get('link') || ls.linkUrl || '',
    linkPlatform: p.get('platform') || ls.linkPlatform || '',
    deeperGoals: p.get('vision') || ls.deeperGoals || '',
    dreamClient: p.get('dreamclient') || ls.dreamClient || '',
    goal: p.get('goal') || ls.goal || '',
    industry: p.get('industry') || ls.industry || '',
    stage: p.get('stage') || ls.stage || '',
    frustration: p.get('frustration') || ls.frustration || '',
    tried: p.get('tried') || ls.tried || ''
  };
  var hasAny = data.aboutYou || data.currentBio || data.dreamClient || data.deeperGoals;
  if (hasAny) { try { localStorage.setItem('deepDiveData', JSON.stringify(data)); } catch(e) {} return data; }
  return null;
}

// ---- AI-POWERED BRAND ANALYSIS ----
function generateAIAnalysis(params, archetype, deepDive) {
  var analysisEl = document.getElementById('r-ai-analysis');
  var contentEl = document.getElementById('ai-content');
  var stageLabel = params.stage && STAGE_CONTEXT[params.stage] ? STAGE_CONTEXT[params.stage].label : (params.stage || 'Unknown');
  var frustLabel = params.frustration || 'Not specified';
  var triedList = params.tried && params.tried.length > 0 ? params.tried.join(', ') : 'Nothing yet';
  var stageContext = stageLabel;
  var frustContext = frustLabel;

  // Show the AI section while loading
  if (analysisEl) analysisEl.style.display = 'block';

  var loadingMessages = [
    'Reading your brand DNA...',
    'Analyzing your blind spot pattern...',
    'Cross-referencing your dimensions...',
    'Building personalized insights...',
    'Generating your AI analysis...'
  ];
  var msgIndex = 0;
  var loadingEl = document.querySelector('.ai-loading-text');
  var loadingInterval = setInterval(function() {
    msgIndex = (msgIndex + 1) % loadingMessages.length;
    if (loadingEl) loadingEl.textContent = loadingMessages[msgIndex];
  }, 2500);

  // === SECURE BACKEND CALL ===
  // The Anthropic API key used to live here in plaintext (it got scraped on
  // 2026-04-27 and burned ~$120 of unauthorized usage). It now lives as
  // BBR_ANTHROPIC_KEY inside the bbr-generate Supabase edge function and is
  // never sent to the browser. The edge function verifies Stripe payment via
  // bbr_purchases, calls Claude server-side, persists to bbr_reports,
  // emails the report via Resend, and fires the Make.com tag webhook.

  // Read stripe_session_id from localStorage (set by deep-dive page) or URL fallback
  var stripeSessionId = '';
  try { stripeSessionId = localStorage.getItem('bbrStripeSessionId') || ''; } catch(e) {}
  if (!stripeSessionId) {
    var urlSid = new URLSearchParams(window.location.search);
    stripeSessionId = urlSid.get('session_id') || urlSid.get('stripe_session_id') || '';
  }

  // Read email — params.email first, then fall back to localStorage from quiz
  var bbrEmail = params.email || '';
  if (!bbrEmail) {
    try { bbrEmail = localStorage.getItem('quizEmail') || ''; } catch(e) {}
  }

  fetch('https://nwazrnuqkauwahyshjrt.supabase.co/functions/v1/bbr-generate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      stripe_session_id: stripeSessionId,
      email: bbrEmail,
      name: params.name || '',
      scores: {
        m: params.m,
        s: params.s,
        st: params.st,
        p: params.path,
        overall: params.score,
        type: params.type
      },
      deep_dive: deepDive || {}
    })
  }).then(function(response) {
    if (!response.ok) {
      throw new Error('API ' + response.status);
    }
    return response.json();
  }).then(function(data) {
    clearInterval(loadingInterval);

    if (!data.success || !data.report) {
      throw new Error('Invalid response: ' + JSON.stringify(data));
    }
    var analysis = data.report;

    // === RENDER THE ENHANCED ANALYSIS ===
    var html = '';

    // 1. MIRROR STATEMENT
    if (analysis.mirrorStatement) {
      html += '<div class="ai-block ai-mirror">';
      html += '<div class="ai-block-label">What We See</div>';
      html += '<p class="ai-mirror-text">' + analysis.mirrorStatement + '</p>';
      html += '</div>';
    }

    // 2. BIO TEARDOWN
    if (analysis.bioTeardown) {
      html += '<div class="ai-block ai-teardown">';
      html += '<div class="ai-block-label">Your Bio Teardown</div>';
      if (deepDive.currentBio) {
        html += '<div class="ai-original-bio">';
        html += '<span class="ai-original-label">YOUR CURRENT BIO:</span>';
        html += '<p class="ai-original-text">"' + escapeHtml(deepDive.currentBio) + '"</p>';
        html += '</div>';
      }
      html += '<p>' + analysis.bioTeardown + '</p>';
      html += '</div>';
    }

    // 3. REWRITTEN BIO
    if (analysis.bioRewrite) {
      html += '<div class="ai-block ai-deliverable">';
      html += '<div class="ai-block-label">Your New Bio (Short)</div>';
      html += '<div class="ai-copyable" id="ai-bio-text">' + escapeHtml(analysis.bioRewrite) + '</div>';
      html += '<button class="ai-copy-btn" onclick="copyToClip(\'ai-bio-text\', this)">Copy Bio</button>';
      html += '</div>';
    }

    // 4. EXTENDED BIO
    if (analysis.bioRewriteLong) {
      html += '<div class="ai-block ai-deliverable">';
      html += '<div class="ai-block-label">Your New Bio (Extended)</div>';
      html += '<div class="ai-copyable" id="ai-bio-long">' + escapeHtml(analysis.bioRewriteLong) + '</div>';
      html += '<button class="ai-copy-btn" onclick="copyToClip(\'ai-bio-long\', this)">Copy Extended Bio</button>';
      html += '</div>';
    }

    // 5. CLEAN ELEVATOR PITCH
    if (analysis.elevatorPitchClean) {
      html += '<div class="ai-block ai-deliverable">';
      html += '<div class="ai-block-label">Your Elevator Pitch (Cleaned Up)</div>';
      if (deepDive.aboutYou) {
        html += '<div class="ai-original-bio">';
        html += '<span class="ai-original-label">WHAT YOU TOLD US:</span>';
        html += '<p class="ai-original-text">"' + escapeHtml(deepDive.aboutYou) + '"</p>';
        html += '</div>';
      }
      html += '<div class="ai-copyable" id="ai-pitch">' + escapeHtml(analysis.elevatorPitchClean) + '</div>';
      html += '<button class="ai-copy-btn" onclick="copyToClip(\'ai-pitch\', this)">Copy Pitch</button>';
      html += '</div>';
    }

    // 6. POSITIONING STATEMENT
    if (analysis.positionStatement) {
      html += '<div class="ai-block ai-deliverable ai-highlight">';
      html += '<div class="ai-block-label">Your Position Statement</div>';
      html += '<div class="ai-copyable ai-position" id="ai-position-text">' + escapeHtml(analysis.positionStatement) + '</div>';
      html += '<button class="ai-copy-btn" onclick="copyToClip(\'ai-position-text\', this)">Copy Position</button>';
      html += '</div>';
    }

    // 7. LINK-IN-BIO ANALYSIS
    if (analysis.linkAnalysis) {
      html += '<div class="ai-block">';
      html += '<div class="ai-block-label">Link-in-Bio Teardown</div>';
      if (deepDive.linkUrl) {
        html += '<p class="ai-link-ref"><a href="' + (deepDive.linkUrl.indexOf('http') === 0 ? deepDive.linkUrl : 'https://' + deepDive.linkUrl) + '" target="_blank" rel="noopener">' + escapeHtml(deepDive.linkUrl) + '</a>';
        if (deepDive.linkPlatform) html += ' <span class="ai-platform-tag">' + escapeHtml(deepDive.linkPlatform) + '</span>';
        html += '</p>';
      }
      html += '<p>' + analysis.linkAnalysis + '</p>';
      html += '</div>';
    }

    // 8. BLIND SPOT MIRROR
    if (analysis.blindSpotMirror) {
      html += '<div class="ai-block ai-mirror">';
      html += '<div class="ai-block-label">Your Blind Spot Connection</div>';
      html += '<p>' + analysis.blindSpotMirror + '</p>';
      html += '</div>';
    }

    // 8b. DREAM CLIENT STRATEGY
    if (analysis.dreamClientStrategy) {
      html += '<div class="ai-block ai-dream-client">';
      html += '<div class="ai-block-label">Your Dream Client Strategy</div>';
      html += '<p>' + analysis.dreamClientStrategy + '</p>';
      html += '</div>';
    }

    // 9. 30/60/90 ROADMAP
    if (analysis.thirtyDayPlan || analysis.sixtyDayMilestone || analysis.ninetyDayVision) {
      html += '<div class="ai-block ai-roadmap-personal">';
      html += '<div class="ai-block-label">Your Personalized 90-Day Roadmap</div>';

      if (analysis.thirtyDayPlan) {
        html += '<div class="ai-roadmap-phase">';
        html += '<div class="ai-phase-label">Days 1-30: Foundation</div>';
        html += '<div class="ai-phase-body" id="ai-30day">' + formatNumberedList(analysis.thirtyDayPlan) + '</div>';
        html += '</div>';
      }
      if (analysis.sixtyDayMilestone) {
        html += '<div class="ai-roadmap-phase">';
        html += '<div class="ai-phase-label">Day 60: Milestone</div>';
        html += '<p>' + analysis.sixtyDayMilestone + '</p>';
        html += '</div>';
      }
      if (analysis.ninetyDayVision) {
        html += '<div class="ai-roadmap-phase">';
        html += '<div class="ai-phase-label">Day 90: The Vision</div>';
        html += '<p>' + analysis.ninetyDayVision + '</p>';
        html += '</div>';
      }

      html += '<button class="ai-copy-btn" onclick="copyRoadmap()">Copy Full Roadmap</button>';
      html += '</div>';
    }

    // 10. DM SCRIPTS
    if (analysis.dmScript) {
      html += '<div class="ai-block ai-deliverable">';
      html += '<div class="ai-block-label">Your DM Script (Copy + Send)</div>';
      html += '<div class="ai-dm-sequence" id="ai-dm-script">' + formatDMScript(analysis.dmScript) + '</div>';
      html += '<button class="ai-copy-btn" onclick="copyToClip(\'ai-dm-script\', this)">Copy DM Script</button>';
      html += '</div>';
    }

    // 11. CONTENT HOOKS
    if (analysis.contentHook) {
      html += '<div class="ai-block ai-deliverable">';
      html += '<div class="ai-block-label">3 Content Hooks for This Week</div>';
      html += '<div class="ai-hooks" id="ai-hooks">' + formatNumberedList(analysis.contentHook) + '</div>';
      html += '<button class="ai-copy-btn" onclick="copyToClip(\'ai-hooks\', this)">Copy Hooks</button>';
      html += '</div>';
    }

    loadingEl.style.display = 'none';
    var aiLoadingWrap = document.getElementById('ai-loading');
    if (aiLoadingWrap) aiLoadingWrap.style.display = 'none';
    contentEl.innerHTML = html;
    contentEl.style.display = 'block';

    // Store for export
    window._aiAnalysis = analysis;

    // Update roadmap Step 1 if we got personalized content
    if (analysis.thirtyDayPlan) {
      var step1Body = document.querySelector('.roadmap-step:first-child .step-body');
      if (step1Body) step1Body.innerHTML = formatNumberedList(analysis.thirtyDayPlan);
    }

  }).catch(function(err) {
    clearInterval(loadingInterval);
    console.error('AI analysis error:', err);
    analysisEl.style.display = 'none';
    document.querySelectorAll('.report').forEach(function(r){r.classList.add('visible')});
    var aiLoad = document.getElementById('ai-loading'); if(aiLoad) aiLoad.style.display='none';
  });
}

// ---- HELPER: Escape HTML ----
function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

// ---- HELPER: Format numbered list ----
function formatNumberedList(str) {
  if (!str) return '';
  var items = str.split(/\d+\.\s+/).filter(Boolean);
  if (items.length <= 1) return '<p>' + str + '</p>';
  return '<ol class="ai-numbered">' + items.map(function(item) { return '<li>' + item.trim() + '</li>'; }).join('') + '</ol>';
}

// ---- HELPER: Format DM script ----
function formatDMScript(str) {
  if (!str) return '<p>' + str + '</p>';
  var msgs = str.split(/Message\s*\d+\s*:\s*|\|\s*Message\s*\d+\s*:\s*/).filter(Boolean);
  if (msgs.length <= 1) {
    var pipeMsgs = str.split(/\s*\|\s*/).filter(Boolean);
    if (pipeMsgs.length > 1) {
      return pipeMsgs.map(function(m, i) { return '<div class="ai-dm-msg"><span class="ai-dm-num">Message ' + (i + 1) + '</span><p>' + m.trim() + '</p></div>'; }).join('');
    }
    return '<p>' + str + '</p>';
  }
  return msgs.map(function(m, i) { return '<div class="ai-dm-msg"><span class="ai-dm-num">Message ' + (i + 1) + '</span><p>' + m.trim() + '</p></div>'; }).join('');
}

// ---- COPY HELPERS ----
function copyToClip(elId, btn) {
  var el = document.getElementById(elId);
  if (!el) return;
  var text = el.textContent || el.innerText;
  navigator.clipboard.writeText(text).then(function() {
    var orig = btn.textContent;
    btn.textContent = 'Copied!';
    btn.classList.add('copied');
    setTimeout(function() { btn.textContent = orig; btn.classList.remove('copied'); }, 2000);
  }).catch(function() {
    var ta = document.createElement('textarea');
    ta.value = text;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    var orig = btn.textContent;
    btn.textContent = 'Copied!';
    setTimeout(function() { btn.textContent = orig; }, 2000);
  });
}

function copyRoadmap() {
  var analysis = window._aiAnalysis;
  if (!analysis) return;
  var text = '90-DAY BRAND ROADMAP\n\n';
  if (analysis.thirtyDayPlan) text += 'DAYS 1-30: FOUNDATION\n' + analysis.thirtyDayPlan + '\n\n';
  if (analysis.sixtyDayMilestone) text += 'DAY 60: MILESTONE\n' + analysis.sixtyDayMilestone + '\n\n';
  if (analysis.ninetyDayVision) text += 'DAY 90: THE VISION\n' + analysis.ninetyDayVision + '\n';
  navigator.clipboard.writeText(text).then(function() {
    var btns = document.querySelectorAll('.ai-roadmap-personal .ai-copy-btn');
    btns.forEach(function(btn) {
      var orig = btn.textContent;
      btn.textContent = 'Copied!';
      btn.classList.add('copied');
      setTimeout(function() { btn.textContent = orig; btn.classList.remove('copied'); }, 2000);
    });
  });
}

function copyAIBio() {
  copyToClip('ai-bio-text', document.querySelector('#ai-bio-text + .ai-copy-btn'));
}
function copyAIPosition() {
  copyToClip('ai-position-text', document.querySelector('#ai-position-text + .ai-copy-btn'));
}


// ---- DEEP-DIVE PERSONALIZATION ENGINE (Barnum Effect) ----
var STAGE_CONTEXT = {
  'just-starting': {
    label: 'Just Getting Started',
    costInject: "You haven\u2019t launched yet - and every day without a clear brand identity is a day your future competitors are claiming the space you should own. The longer you wait to get this right, the more ground you give away for free.",
    actionFrame: "laying the right foundation before bad habits calcify"
  },
  'side-hustle': {
    label: 'Side Hustle Mode',
    costInject: "You\u2019re splitting your energy between a day job and a dream. An unclear brand means the limited hours you DO invest aren\u2019t converting - and every wasted hour is one you can\u2019t get back.",
    actionFrame: "making your limited hours count by building a brand that works when you can\u2019t"
  },
  'full-time-stuck': {
    label: 'Full-Time but Stuck',
    costInject: "You went all-in. You bet on yourself. But growth has flatlined, and the brand that got you here isn\u2019t the brand that gets you there. Stalling isn\u2019t neutral - it\u2019s expensive. Every month of plateau is revenue you\u2019re leaving on the table.",
    actionFrame: "breaking through the plateau with a brand that matches your next level"
  },
  'growing-chaotic': {
    label: 'Growing but Chaotic',
    costInject: "Revenue\u2019s coming in, but it feels random. You can\u2019t predict what\u2019s working or why. Without a brand system, you\u2019re scaling chaos - and chaos doesn\u2019t compound.",
    actionFrame: "turning chaotic growth into predictable, scalable momentum"
  },
  'established-invisible': {
    label: 'Established but Invisible',
    costInject: "You\u2019ve put in the years. You\u2019ve got the experience. But the market doesn\u2019t reflect it - your brand age doesn\u2019t match your brand authority. You\u2019re the best-kept secret in your space, and that\u2019s the most expensive secret you can keep.",
    actionFrame: "making your experience visible so the market finally catches up"
  },
  'growing-stuck': {
    label: 'Growing but Stuck',
    costInject: "You're not failing - you're plateauing. Revenue comes in but it won't scale, and every month at this ceiling costs you the momentum that got you here. Stuck isn't stable. Stuck is slowly bleeding the energy that built this thing.",
    actionFrame: "breaking through the growth ceiling with a brand that opens doors instead of blending in"
  },
  'established-refinement': {
    label: 'Established, Needs Refinement',
    costInject: "You've built something real. Clients come, revenue flows. But you know it could be sharper - tighter - more intentional. The gap between where you are and where your brand should be isn't fatal, but it's expensive. Every day your brand undersells your actual caliber is a day premium clients choose someone who looks the part.",
    actionFrame: "refining the brand to match the business you've already built"
  },
  'rebuilding': {
    label: 'Rebuilding / Pivoting',
    costInject: "You're not starting over - you're starting right. But a pivot without a clear brand is just motion without direction. The market doesn't know who you are anymore, and every week of ambiguity is a week your new positioning loses ground to someone with a clearer story.",
    actionFrame: "rebuilding with intention so the pivot actually lands"
  }
};

var FRUSTRATION_MIRROR = {
  'cant-explain': function(archName) { return 'You told us the #1 thing holding you back is that <strong>people don\u2019t understand what you do.</strong> That\u2019s not their failure - it\u2019s a ' + archName + ' symptom. Your talent is real. Your ability to translate it isn\u2019t. Yet.'; },
  'wrong-clients': function(archName) { return 'You said you\u2019re <strong>attracting the wrong people</strong> - or none at all. Classic ' + archName + ' pattern. Your signal is pulling in mismatches because the brand you\u2019re putting out doesn\u2019t match the value you deliver.'; },
  'underpriced': function(archName) { return 'You feel <strong>underpriced for the value you deliver.</strong> That\u2019s your ' + archName + ' blind spot making pricing decisions for you. Your work is premium. Your packaging isn\u2019t telling that story.'; },
  'look-generic': function(archName) { return 'You said you <strong>look and sound like everyone else.</strong> That\u2019s not a design problem - it\u2019s a ' + archName + ' problem. New colors won\u2019t fix it. A new position will.'; },
  'cant-differentiate': function(archName) { return 'You told us you <strong>can\u2019t explain what makes you different.</strong> The ' + archName + ' pattern is hiding your differentiator in plain sight. It\u2019s there - you just can\u2019t see it because you\u2019re inside it.'; },
  'not-enough-clients': function(archName) { return 'You said the bottom line is simple: <strong>not enough clients.</strong> That\'s not a marketing problem - it\'s a ' + archName + ' problem. You\'re visible but not magnetic. People see you but don\'t feel the pull. Fix the signal, fix the pipeline.'; },
  'no-direction': function(archName) { return 'You told us you have <strong>no clear direction</strong> - you\'re working hard but not toward anything specific. That\'s your ' + archName + ' blind spot running the show. Without a defined brand position, every decision feels like a guess because it is one.'; },
  'content-not-converting': function(archName) { return 'You\'re showing up. You\'re posting. But <strong>the content isn\'t converting.</strong> That\'s not a content problem - it\'s a ' + archName + ' problem. Your message isn\'t landing because the brand underneath it doesn\'t have a clear enough identity to make people act.'; }
};

var TRIED_REFLECTION = {
  'rebrand': "You tried a visual rebrand - new logo, new website, new colors. But the packaging changed while the positioning stayed the same. That\u2019s like putting a new frame on a blurry picture.",
  'content': "You pushed harder on social media. More posts, more effort, more consistency. But without message clarity, more content just means more noise. Volume doesn\u2019t fix a targeting problem.",
  'coach': "You invested in a coach or consultant. Smart move - but if they didn\u2019t fix your brand\u2019s blind spot first, the advice couldn\u2019t stick. Strategy without identity is a house without a foundation.",
  'lowered': "You lowered your prices to compete. That\u2019s the trap - racing to the bottom when you should be climbing. Every discount trained your market to expect less from you.",
  'pivoted': "You changed your offer or pivoted entirely. Sometimes that\u2019s the right call. But pivoting without fixing the root cause means you\u2019ll hit the same wall in a new room.",
  'nothing': "You haven\u2019t tried to fix it yet - and honestly, that might be a good thing. It means you haven\u2019t wasted money on the wrong solutions. You\u2019re starting clean."
};

var GOAL_FRAMING = {
  'consistent-income': {
    label: 'Consistent Income',
    frame: "To build consistent income doing what you love, your brand needs to sell when you\u2019re not in the room. Right now, it\u2019s not. Here\u2019s how to change that.",
    future: "Imagine waking up to DMs from people who already understand what you do, already trust you, and are ready to pay. That\u2019s what a clear brand does - it works the midnight shift."
  },
  'quit-job': {
    label: 'Full-Time Freedom',
    frame: "To make the leap from 9-to-5 to full-time, you need a brand that generates leads while you\u2019re still clocked in at the day job. One that doesn\u2019t need you hustling every hour to stay alive.",
    future: "Picture this: your brand is attracting clients on autopilot. Your side income matches your salary. The leap isn\u2019t scary anymore - it\u2019s inevitable. That\u2019s what clarity creates."
  },
  'premium-clients': {
    label: 'Premium Clients',
    frame: "To attract premium clients who pay what you\u2019re worth, your brand needs to signal premium before you ever open your mouth. Right now, it\u2019s signaling something else.",
    future: "Imagine never having to justify your price again. Clients come to you because your brand screams quality. They don\u2019t ask for discounts - they ask how soon you can start."
  },
  'authority': {
    label: 'Category Auth/rity',
    frame: "To become THE go-to in your space, your brand needs to be unmistakable - not just good, but the obvious choice. Right now, you\u2019re one of many. Here\u2019s how to become the only one.",
    future: "Picture being the name people say when someone asks \u2018who should I talk to about this?\u2019 That\u2019s authority. And it starts with a brand that\u2019s impossible to confuse with anyone else."
  },
  'freedom': {
    label: 'Brand Freedom',
    frame: "To build a brand that runs without you hustling 24/7, every touchpoint needs to convert without your physical presence. Your brand needs to be a system, not a personality.",
    future: "Imagine taking a week off and coming back to new clients, new revenue, new conversations - all because your brand kept working. That\u2019s freedom. And it\u2019s built, not wished for."
  }
};

function getTriedSummary(tried) {
  if (!tried || tried.length === 0 || (tried.length === 1 && tried[0] === 'nothing')) return TRIED_REFLECTION['nothing'];
  var reflections = tried.filter(function(t) { return t !== 'nothing'; }).map(function(t) { return TRIED_REFLECTION[t] || ''; }).filter(Boolean);
  if (reflections.length === 0) return TRIED_REFLECTION['nothing'];
  if (reflections.length === 1) return reflections[0];
  return reflections.slice(0, 2).join(' ');
}

function hasDeepDive(params) {
  return params.stage || params.frustration || params.goal;
}

// ---- ANIMATED COUNTER ----
function animateCounter(el, target) {
  var current = 0;
  var duration = 2000;
  var start = performance.now();
  function step(ts) {
    var elapsed = ts - start;
    var progress = Math.min(elapsed / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    current = Math.round(eased * target);
    el.innerHTML = current + '<sup>/100</sup>';
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// ---- RADAR CHART (SVG) ----
function drawRadar(scores) {
  var dims = ['MESSAGE', 'SIGNAL', 'STANCE', 'PATH'];
  var labels = ['Message', 'Signal', 'Stance', 'Path'];
  var cx = 150, cy = 150, maxR = 110;
  var angleStep = (Math.PI * 2) / 4;
  var startAngle = -Math.PI / 2;

  var svg = '';

  // Grid rings
  [25, 50, 75, 100].forEach(function(pct) {
    var r = (pct / 100) * maxR;
    svg += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="rgba(26,26,26,0.06)" stroke-width="1"/>';
  });

  // Grid lines + labels
  dims.forEach(function(d, i) {
    var angle = startAngle + i * angleStep;
    var x2 = cx + Math.cos(angle) * maxR;
    var y2 = cy + Math.sin(angle) * maxR;
    svg += '<line x1="' + cx + '" y1="' + cy + '" x2="' + x2 + '" y2="' + y2 + '" stroke="rgba(26,26,26,0.06)" stroke-width="1"/>';
    var lx = cx + Math.cos(angle) * (maxR + 20);
    var ly = cy + Math.sin(angle) * (maxR + 20);
    svg += '<text x="' + lx + '" y="' + ly + '" text-anchor="middle" dominant-baseline="middle" fill="#6B6B6B" font-size="11" font-family="Inter,sans-serif" font-weight="500" letter-spacing="0.04em">' + labels[i] + '</text>';
  });

  // Data polygon
  var points = dims.map(function(d, i) {
    var val = scores[d] || 0;
    var r = (val / 100) * maxR;
    var angle = startAngle + i * angleStep;
    return (cx + Math.cos(angle) * r) + ',' + (cy + Math.sin(angle) * r);
  }).join(' ');

  svg += '<polygon points="' + points + '" fill="rgba(91,107,53,0.12)" stroke="#5B6B35" stroke-width="2"/>';

  // Data points
  dims.forEach(function(d, i) {
    var val = scores[d] || 0;
    var r = (val / 100) * maxR;
    var angle = startAngle + i * angleStep;
    var px = cx + Math.cos(angle) * r;
    var py = cy + Math.sin(angle) * r;
    svg += '<circle cx="' + px + '" cy="' + py + '" r="4" fill="#5B6B35"/>';
  });

  document.getElementById('radar-chart').innerHTML = svg;
}

// ---- LEGEND BARS ----
function drawLegend(scores, weakDim) {
  var dims = ['MESSAGE', 'SIGNAL', 'STANCE', 'PATH'];
  var html = '';
  dims.forEach(function(d) {
    var val = scores[d];
    var barClass = val >= 65 ? 'good' : val >= 40 ? 'mid' : 'low';
    var isWeak = d === weakDim;
    html += '<div class="legend-item">'
      + '<span class="legend-label"' + (isWeak ? ' style="color:var(--olive);font-weight:700"' : '') + '>' + DIM_LABELS[d] + '</span>'
      + '<div class="legend-bar"><div class="legend-fill ' + barClass + '" style="width:0%" data-target="' + val + '"></div></div>'
      + '<span class="legend-value">' + val + '%</span>'
      + '</div>';
  });
  document.getElementById('radar-legend').innerHTML = html;

  // Animate bars after render
  setTimeout(function() {
    document.querySelectorAll('.legend-fill').forEach(function(bar) {
      bar.style.width = bar.dataset.target + '%';
    });
  }, 300);
}

// ---- BUILD ROADMAP ----
function buildRoadmap(steps) {
  var container = document.getElementById('p-roadmap');
  if (!container) return;
  steps.forEach(function(s, i) {
    var isLocked = s.locked;
    var html = '<div class="roadmap-step ' + (isLocked ? 'step-locked' : '') + ' reveal">'
      + '<div class="step-number">' + (i + 1) + '</div>'
      + '<div class="step-label">' + s.label + '</div>'
      + '<div class="step-title" style="font-family:var(--font-display);font-size:clamp(18px,4vw,22px);letter-spacing:0.02em;margin-bottom:8px">' + s.title + '</div>'
      + '<p class="step-body">' + s.body + '</p>'
      + (isLocked ? '<div class="lock-badge">\ud83d\udd12 Full roadmap in the Reinvention OS</div>' : '')
      + '</div>';
    container.insertAdjacentHTML('beforeend', html);
  });
}

// ---- SCORE CONTEXT ----
function getScoreContext(score, name) {
  if (score >= 80) return name + ', your brand fundamentals are strong. But even a score this high has a blind spot worth finding.';
  if (score >= 60) return 'You\u2019re not starting from zero, ' + name + '. But the gap between where you are and where you should be is costing you real money.';
  if (score >= 40) return name + ', your brand is working against you on <strong>' + (100 - score) + '% of its touchpoints.</strong> That\u2019s not a tweak - that\u2019s a transformation waiting to happen.';
  return name + ', this score means your brand is actively repelling the people it should be attracting. <strong>The good news: this is fixable.</strong> And knowing the number is the first step.';
}

// ---- LOADING SEQUENCE ----
function runLoadingSequence(callback) {
  var steps = [
    {text: 'Analyzing your Brand Clarity Score\u2122...', pct: 15},
    {text: 'Mapping your 4-dimension breakdown...', pct: 35},
    {text: 'Identifying your primary blind spot...', pct: 55},
    {text: 'Calculating revenue impact...', pct: 75},
    {text: 'Building your personalized roadmap...', pct: 90},
    {text: 'Report ready.', pct: 100}
  ];
  var fill = document.getElementById('load-fill');
  var stepEl = document.getElementById('load-step');
  var i = 0;

  function next() {
    if (i >= steps.length) {
      setTimeout(function() {
        document.getElementById('loader').classList.add('done');
        callback();
      }, 600);
      return;
    }
    fill.style.width = steps[i].pct + '%';
    stepEl.textContent = steps[i].text;
    i++;
    setTimeout(next, 600 + Math.random() * 400);
  }
  setTimeout(next, 400);
}

// ---- SCROLL REVEAL ----
function initScrollReveal() {
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        observer.unobserve(e.target);
      }
    });
  }, {threshold: 0.15});
  document.querySelectorAll('.reveal').forEach(function(el) { observer.observe(el); });
}

// ---- INIT ----
function init() {
  var params = getParams();
  var type = ARCHETYPES[params.type] ? params.type : 'MESSAGE';
  var arch = ARCHETYPES[type];
  var scores = {MESSAGE: params.m, SIGNAL: params.s, STANCE: params.st, PATH: params.path};
  var deep = hasDeepDive(params);
  var stage = STAGE_CONTEXT[params.stage];
  var goalData = GOAL_FRAMING[params.goal];
  var industryLabel = params.industry || 'your field';
  var deepDiveData = getDeepDiveData();

  // Determine weak dimension
  var dims = ['MESSAGE', 'SIGNAL', 'STANCE', 'PATH'];
  var weakDim = type === 'COMPOUND' ? dims.reduce(function(a, b) { return scores[a] < scores[b] ? a : b; }) : type;

  runLoadingSequence(function() {
    document.querySelectorAll('.report').forEach(function(r){r.classList.add('visible')});
    var report = document.getElementById('report');
    report.classList.add('visible');

    // Header
    document.getElementById('r-greeting').textContent = 'Prepared for ' + params.name;

    // Score
    animateCounter(document.getElementById('r-score'), params.score);
    document.getElementById('r-score-ctx').innerHTML = getScoreContext(params.score, params.name);

    // Radar
    drawRadar(scores);
    drawLegend(scores, weakDim);

    // Archetype
    document.getElementById('r-archetype').textContent = arch.name;
    document.getElementById('r-tagline').textContent = arch.tagline;

    // === DEEP-DIVE PROFILE CARD ===
    if (deep) {
      var profileEl = document.getElementById('r-profile');
      if (profileEl) {
        var frustrationLabels = {
          'cant-explain': 'People don\'t get what I do',
          'wrong-clients': 'Attracting wrong clients',
          'underpriced': 'Underpriced for my value',
          'look-generic': 'Look like everyone else',
          'cant-differentiate': 'Can\'t explain my difference',
          'not-enough-clients': 'Not Enough Clients',
          'no-direction': 'No Clear Direction',
          'content-not-converting': 'Content Not Converting'
        };
        var triedLabels = {
          'rebrand': 'Visual Rebrand',
          'content': 'Content Push',
          'coach': 'Hired a Coach',
      'ads': 'Paid Ads',
      'website': 'New Website',
      'designer': 'Hired a Designer',
          'lowered': 'Lowered Prices',
          'pivoted': 'Pivoted Offer',
          'nothing': 'Nothing Yet'
        };

        var profileHTML = '<span class="section-label">Your Brand Snapshot</span>';
        profileHTML += '<div class="profile-grid">';
        if (stage) profileHTML += '<div class="profile-item"><span class="profile-key">Stage</span><span class="profile-val">' + stage.label + '</span></div>';
        if (params.frustration && FRUSTRATION_MIRROR[params.frustration]) profileHTML += '<div class="profile-item"><span class="profile-key">#1 Frustration</span><span class="profile-val">' + (frustrationLabels[params.frustration] || params.frustration) + '</span></div>';
        if (goalData) profileHTML += '<div class="profile-item"><span class="profile-key">Goal</span><span class="profile-val">' + goalData.label + '</span></div>';
        if (params.industry) profileHTML += '<div class="profile-item"><span class="profile-key">Industry</span><span class="profile-val">' + params.industry + '</span></div>';
        if (params.tried && params.tried.length > 0 && !(params.tried.length === 1 && params.tried[0] === 'nothing')) {
          profileHTML += '<div class="profile-item profile-wide"><span class="profile-key">Already Tried</span><span class="profile-val">' + params.tried.map(function(t) { return triedLabels[t] || t; }).join(', ') + '</span></div>';
        }
        // Deep-dive enrichment from localStorage
        if (deepDiveData) {
          if (deepDiveData.aboutYou) profileHTML += '<div class="profile-item profile-wide"><span class="profile-key">About You</span><span class="profile-val">' + deepDiveData.aboutYou + '</span></div>';
          if (deepDiveData.currentBio) profileHTML += '<div class="profile-item profile-wide"><span class="profile-key">Current Bio</span><span class="profile-val" style="font-style:italic">"' + deepDiveData.currentBio + '"</span></div>';
          if (deepDiveData.linkUrl) profileHTML += '<div class="profile-item profile-wide"><span class="profile-key">Link-in-Bio</span><span class="profile-val"><a href="' + (deepDiveData.linkUrl.indexOf('http') === 0 ? deepDiveData.linkUrl : 'https://' + deepDiveData.linkUrl) + '" target="_blank" rel="noopener" style="color:var(--accent);text-decoration:underline">' + deepDiveData.linkUrl + '</a>' + (deepDiveData.linkPlatform ? ' (' + deepDiveData.linkPlatform + ')' : '') + '</span></div>';
          if (deepDiveData.deeperGoals) profileHTML += '<div class="profile-item profile-wide"><span class="profile-key">Where You Want to Go</span><span class="profile-val">' + deepDiveData.deeperGoals + '</span></div>';
          if (deepDiveData.goal) profileHTML += '<div class="profile-item"><span class="profile-key">Brand Goal</span><span class="profile-val">' + deepDiveData.goal + '</span></div>';
          if (deepDiveData.dreamClient) profileHTML += '<div class="profile-item profile-wide"><span class="profile-key">Dream Client</span><span class="profile-val">' + deepDiveData.dreamClient + '</span></div>';
        }
        profileHTML += '</div>';
        profileEl.innerHTML = profileHTML;
        profileEl.style.display = 'block';
      }
    }

    // === CALLOUT - with frustration mirror ===
    var calloutHTML = arch.callout(params.name);
    if (deep && params.frustration && FRUSTRATION_MIRROR[params.frustration]) {
      calloutHTML += '<div class="deep-inject frustration-mirror"><p>' + FRUSTRATION_MIRROR[params.frustration](arch.name) + '</p></div>';
    }
    document.getElementById('r-callout').innerHTML = calloutHTML;

    // === COST - with stage context + tried reflection ===
    var costHTML = arch.cost;
    if (deep) {
      var costExtra = '';
      if (stage) {
        costExtra += '<div class="deep-inject stage-context"><p class="context-label">\ud83d\udccd As someone ' + stage.label.toLowerCase() + ':</p><p>' + stage.costInject + '</p></div>';
      }
      if (params.tried && params.tried.length > 0) {
        var triedText = getTriedSummary(params.tried);
        if (triedText) costExtra += '<div class="deep-inject tried-reflection"><p class="context-label">\ud83d\udd01 What you\u2019ve already tried:</p><p>' + triedText + '</p></div>';
      }
      costHTML += costExtra;
    }
    document.getElementById('r-cost').innerHTML = costHTML;

    // === SHIFT - with goal framing + deep-dive personalization ===
    var shiftHTML = '<span class="section-label">Section 4 - The One Shift That Changes Everything</span><p class="shift-text">' + arch.shift + '</p>';
    if (deep && goalData) {
      shiftHTML += '<div class="deep-inject goal-frame"><p class="context-label">\ud83c\udfaf Your goal: ' + goalData.label + '</p><p>' + goalData.frame + '</p></div>';
      if (params.industry) shiftHTML += '<p class="industry-note">In <strong>' + industryLabel + '</strong>, this shift is the difference between being another option and being the obvious choice.</p>';
    }
    if (deepDiveData) {
      if (deepDiveData.currentBio) shiftHTML += '<div class="deep-inject"><p class="context-label">\ud83d\udcdd Look at your current bio:</p><p style="font-style:italic;opacity:0.85">"' + deepDiveData.currentBio + '"</p><p>Now ask yourself: does someone reading that for the first time know what outcome you deliver? That is the shift. Lead with the result, not the resume.</p></div>';
      if (deepDiveData.deeperGoals) shiftHTML += '<div class="deep-inject"><p class="context-label">\ud83d\udd2e You said you want to:</p><p style="font-style:italic;opacity:0.85">"' + deepDiveData.deeperGoals + '"</p><p>That future starts with this single shift. Everything downstream - pricing, content, clients - realigns once this is fixed.</p></div>';
      if (deepDiveData.dreamClient) shiftHTML += '<div class="deep-inject"><p class="context-label">\ud83d\udc8e Your dream client:</p><p style="font-style:italic;opacity:0.85">"' + deepDiveData.dreamClient + '"</p><p>That person is out there right now, looking for exactly what you do. The only reason they have not found you yet? Your brand is not speaking their language. Fix the blind spot, and you become magnetic to this exact buyer.</p></div>';
    }
    document.getElementById('r-shift').innerHTML = shiftHTML;

    // === ACTION - with goal future vision + deep-dive specifics ===
    var actionHTML = '<span class="section-label">Your Immediate Action Step</span><p class="action-text">' + arch.action + '</p>';
    if (deep && goalData) {
      actionHTML += '<div class="deep-inject future-vision"><p class="context-label">\u2728 Where this leads:</p><p>' + goalData.future + '</p></div>';
      if (stage) actionHTML += '<p class="action-frame-note">For someone ' + stage.actionFrame + ', this action step is non-negotiable.</p>';
    }
    if (deepDiveData && deepDiveData.aboutYou) {
      var aboutSnippet = deepDiveData.aboutYou.length > 120 ? deepDiveData.aboutYou.substring(0, 120) + '...' : deepDiveData.aboutYou;
      actionHTML += '<div class="deep-inject"><p class="context-label">\ud83c\udfaf Tailored to you:</p><p>You described yourself as someone who "' + aboutSnippet + '" - which means the generic version of this advice won\u2019t cut it. Your first move needs to be specific to <em>your</em> situation. ' + (deepDiveData.linkUrl ? 'Start with your link-in-bio. That is the first thing new people see, and right now it is not doing the job.' : 'Start with how you introduce yourself online. That is the first thing new people see.') + '</p></div>';
    }
    document.getElementById('r-action').innerHTML = actionHTML;

    // Roadmap
    buildRoadmap(arch.roadmapSteps);

    // === EXPORT TOOLBAR (deep-dive only) ===
    if (deep) {
      var exportEl = document.getElementById('r-export');
      if (exportEl) exportEl.style.display = 'flex';
    }

    // Scroll reveal
    setTimeout(initScrollReveal, 100);

    // === CLAUDE AI ANALYSIS (fires after report renders) ===
    if (deepDiveData) {
      generateAIAnalysis(params, arch, deepDiveData);
    }

    // Fire tag webhook to Make.com (creates/updates Shopify customer)
    sendTagWebhook(params, type);
  });
}

// ---- WEBHOOK: TAG UPDATER ----
function sendTagWebhook(params, archetype) {
  var email = params.email;
  if (!email) {
    // Try quizEmail first (set by quiz-engine.js)
    try { email = localStorage.getItem('quizEmail') || ''; } catch(e) {}
  }
  if (!email) {
    // Fallback: try deepDiveData localStorage
    try {
      var dd = JSON.parse(localStorage.getItem('deepDiveData') || '{}');
      email = dd.email || '';
    } catch(e) {}
  }
  if (!email) {
    // Last resort: try quizData localStorage
    try {
      var qd = JSON.parse(localStorage.getItem('quizData') || '{}');
      email = qd.email || '';
    } catch(e) {}
  }
  if (!email) return; // No email found anywhere, nothing to tag
  // PAYMENT GATE: Only tag as purchased if paid param exists
  // paid=1 must be passed from deep-dive page (set by Stripe success redirect)
  var urlCheck = new URLSearchParams(window.location.search);
  var hasPaid = urlCheck.get('paid') === '1';
  var tags = ['deep-dive-report'];
  if (hasPaid) tags.push('blindspot-purchased');
  if (archetype) tags.push('archetype-' + archetype.toLowerCase());
  if (params.score) tags.push('score-' + params.score);
  if (params.stage) tags.push('stage-' + params.stage);
  if (params.goal) tags.push('goal-' + params.goal);
  var payload = {
    email: email,
    name: params.name || '',
    tags: tags.join(',')
  };
  try {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', 'https://hook.us2.make.com/5sjfkrga6myos83xfyvu9pio6ezudrvt', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(payload));
  } catch(e) { /* silent fail - non-critical */ }
}

// ---- EXPORT: PRINT/PDF ----
function exportPDF() {
  // Load html2pdf.js from CDN if not already loaded
  if (typeof html2pdf === 'undefined') {
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js';
    script.onload = function() { runPDFExport(); };
    script.onerror = function() { alert('PDF library failed to load. Please check your internet connection and try again.'); };
    document.head.appendChild(script);
  } else {
    runPDFExport();
  }
}
function runPDFExport() {
  var reportEl = document.querySelector('.report');
  if (!reportEl) { alert('Report not found. Please reload the page and try again.'); return; }
  var params = getParams();
  var filename = (params.name || 'Brand') + '-Blind-Spot-Report.pdf';
  var btn = document.getElementById('pdf-btn');
  var origText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = 'Generating PDF...'; btn.disabled = true; }

  // Clone report for PDF manipulation
  var clone = reportEl.cloneNode(true);
  clone.className = 'pdf-export-clone';
  // Position on-screen at z-index:-1 (not -9999px) so html2canvas can capture it
  clone.style.cssText = 'width:700px;padding:32px 40px;background:#fff;color:#1a1a1a;opacity:1;visibility:visible;position:fixed;left:0;top:0;z-index:-1;font-family:Inter,Helvetica,Arial,sans-serif;overflow:visible;height:auto;';
  // Inject CSS variable values directly so they resolve in html2canvas context
  clone.style.setProperty('--olive', '#5B6B35');
  clone.style.setProperty('--red-soft', '#c0392b');
  clone.style.setProperty('--accent', '#5B6B35');
  clone.style.setProperty('--font-display', 'Bebas Neue, Impact, sans-serif');
  clone.style.setProperty('--cream', '#fafaf7');
  clone.style.setProperty('--text', '#1a1a1a');
  clone.style.setProperty('--bg', '#ffffff');

  // Force all children visible
  clone.querySelectorAll('.reveal,.section-card,.archetype-card,.score-hero,.radar-wrap,.shift-card,.action-card,.roadmap,.report-header').forEach(function(el) {
    el.style.opacity = '1'; el.style.visibility = 'visible'; el.style.transform = 'none'; el.style.display = '';
  });
  // Show hidden sections that have content
  var prof = clone.querySelector('#r-profile'); if (prof && prof.innerHTML.trim()) prof.style.display = 'block';
  var aiSec = clone.querySelector('#r-ai-analysis'); if (aiSec) { aiSec.style.display = 'block'; var aic = aiSec.querySelector('#ai-content'); if(aic && aic.innerHTML.trim()) aic.style.display = 'block'; }
  var aiLoad = clone.querySelector('#ai-loading'); if (aiLoad) aiLoad.style.display = 'none';

  // Hide export toolbar, proof strip, section dividers, ROS upsell
  clone.querySelectorAll('.export-toolbar,.proof-strip,.section-divider').forEach(function(el) { el.style.display = 'none'; });

  // Convert SVG radar chart to canvas-rendered PNG image
  var svgEl = clone.querySelector('svg.radar-svg, #radar-chart');
  var svgPromise = Promise.resolve();
  if (svgEl) {
    svgPromise = new Promise(function(resolve) {
      try {
        var origSvg = document.querySelector('svg.radar-svg, #radar-chart');
        if (!origSvg) { resolve(); return; }
        var svgData = new XMLSerializer().serializeToString(origSvg);
        var svgBlob = new Blob([svgData], {type: 'image/svg+xml;charset=utf-8'});
        var url = URL.createObjectURL(svgBlob);
        var img = new Image();
        img.onload = function() {
          var canvas = document.createElement('canvas');
          canvas.width = 600; canvas.height = 600;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, 600, 600);
          ctx.drawImage(img, 0, 0, 600, 600);
          var pngUrl = canvas.toDataURL('image/png');
          var newImg = document.createElement('img');
          newImg.src = pngUrl;
          newImg.style.cssText = 'width:280px;height:280px;display:block;margin:0 auto;';
          svgEl.parentNode.replaceChild(newImg, svgEl);
          URL.revokeObjectURL(url);
          resolve();
        };
        img.onerror = function() { resolve(); };
        img.src = url;
      } catch(e) { resolve(); }
    });
  }

  svgPromise.then(function() {
    // Insert explicit page breaks between major sections
    var breakAfter = ['.score-hero', '.radar-wrap', '#r-profile', '#r-ai-analysis', '#r-cost', '.action-card'];
    breakAfter.forEach(function(sel) {
      var el = clone.querySelector(sel);
      if (el && el.innerHTML && el.innerHTML.trim()) {
        var br = document.createElement('div');
        br.className = 'html2pdf__page-break';
        br.style.cssText = 'page-break-before:always;height:0;display:block;';
        if (el.nextSibling) { el.parentNode.insertBefore(br, el.nextSibling); }
        else { el.parentNode.appendChild(br); }
      }
    });

    // Style all section cards for PDF
    clone.querySelectorAll('.section-card,.archetype-card,.cost-card,.shift-card,.action-card,.score-hero,.radar-wrap').forEach(function(el) {
      el.style.background = '#fafaf7';
      el.style.border = '1px solid #e8e8e0';
      el.style.borderRadius = '12px';
      el.style.padding = '24px';
      el.style.marginBottom = '16px';
      el.style.pageBreakInside = 'avoid';
    });

    // Style archetype card dark
    var arch = clone.querySelector('.archetype-card');
    if (arch) { arch.style.background = '#1a1a1a'; arch.style.color = '#fff'; arch.style.textAlign = 'center'; arch.style.padding = '32px'; }

    // Style section labels olive
    clone.querySelectorAll('.section-label').forEach(function(el) {
      el.style.color = '#5B6B35'; el.style.fontSize = '11px'; el.style.letterSpacing = '2px'; el.style.textTransform = 'uppercase'; el.style.fontWeight = '700';
    });

    // Style score number
    var scoreNum = clone.querySelector('.score-number');
    if (scoreNum) { scoreNum.style.fontSize = '64px'; scoreNum.style.fontWeight = '800'; scoreNum.style.color = '#1a1a1a'; scoreNum.style.textAlign = 'center'; }

    // Style roadmap steps
    clone.querySelectorAll('.roadmap-step').forEach(function(el) {
      el.style.background = '#fafaf7'; el.style.border = '1px solid #e8e8e0'; el.style.borderRadius = '10px';
      el.style.padding = '20px'; el.style.marginBottom = '12px'; el.style.pageBreakInside = 'avoid';
    });

    // Add Stolan branding footer
    var footer = document.createElement('div');
    footer.style.cssText = 'text-align:center;padding:24px 0 8px;margin-top:32px;border-top:2px solid #5B6B35;font-size:11px;color:#888;letter-spacing:1px;';
    footer.innerHTML = 'Brand Blind Spot Report\u2122 \u00b7 Powered by Brand Clarity Score\u2122 \u00b7 \u00a9 2026 Stolan Acres';
    clone.appendChild(footer);

    document.body.appendChild(clone);

    // Force reflow so html2canvas measures actual rendered height
    void clone.offsetHeight;

    // Delay to let browser fully paint the clone before capture
    setTimeout(function() {
      // Re-measure after paint
      var captureHeight = Math.max(clone.scrollHeight, clone.offsetHeight, 2000);
      html2pdf().set({
        margin: [10, 12, 10, 12],
        filename: filename,
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          scrollY: 0,
          scrollX: 0,
          x: 0,
          y: 0,
          backgroundColor: '#ffffff',
          width: 700,
          windowWidth: 700,
          logging: false,
          height: captureHeight,
          onclone: function(clonedDoc) {
            var el = clonedDoc.querySelector('.pdf-export-clone');
            if (el) {
              el.style.position = 'relative';
              el.style.left = '0';
              el.style.top = '0';
              el.style.zIndex = 'auto';
              el.style.height = 'auto';
              el.style.overflow = 'visible';
              el.style.setProperty('--olive', '#5B6B35');
              el.style.setProperty('--red-soft', '#c0392b');
              el.style.setProperty('--accent', '#5B6B35');
              el.style.setProperty('--font-display', 'Bebas Neue, Impact, sans-serif');
              el.style.setProperty('--cream', '#fafaf7');
              el.style.setProperty('--text', '#1a1a1a');
            }
          }
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        pagebreak: {
          mode: ['css', 'legacy'],
          before: '.html2pdf__page-break',
          avoid: ['.section-card', '.archetype-card', '.roadmap-step', '.ai-block', '.score-hero', '.radar-wrap']
        }
      }).from(clone).save().then(function() {
        document.body.removeChild(clone);
        if (btn) { btn.textContent = 'Downloaded!'; setTimeout(function() { btn.textContent = origText; btn.disabled = false; }, 2500); }
      }).catch(function(err) {
        console.error('PDF error:', err);
        try { document.body.removeChild(clone); } catch(e) {}
        if (btn) { btn.textContent = 'PDF failed \u2014 try again'; btn.disabled = false; }
        alert('PDF generation encountered an error. Please try again. If the issue persists, try a different browser or clear your cache.');
      });
    }, 500);
  }).catch(function() {
    if (btn) { btn.textContent = 'PDF unavailable \u2014 try again'; btn.disabled = false; }
    alert('Could not load PDF library. Please check your internet connection and try again.');
  });
}

// ---- EXPORT: COPY ACTION PLAN (Enhanced) ----
function copyActionPlan() {
  var params = getParams();
  var type = ARCHETYPES[params.type] ? params.type : 'MESSAGE';
  var arch = ARCHETYPES[type];
  var stage = STAGE_CONTEXT[params.stage];
  var goalData = GOAL_FRAMING[params.goal];
  var ai = window._aiAnalysis || {};

  var plan = 'BRAND BLIND SPOT REPORT - ACTION PLAN\n';
  plan += 'Prepared for: ' + params.name + '\n';
  plan += 'Brand Clarity Score: ' + params.score + '/100\n';
  plan += 'Primary Blind Spot: ' + arch.name + '\n';
  if (stage) plan += 'Stage: ' + stage.label + '\n';
  if (goalData) plan += 'Goal: ' + goalData.label + '\n';
  if (params.industry) plan += 'Industry: ' + params.industry + '\n';

  if (ai.positionStatement) {
    plan += '\n--- YOUR POSITION STATEMENT ---\n' + ai.positionStatement + '\n';
  }
  if (ai.bioRewrite) {
    plan += '\n--- YOUR NEW BIO (SHORT) ---\n' + ai.bioRewrite + '\n';
  }
  if (ai.bioRewriteLong) {
    plan += '\n--- YOUR NEW BIO (EXTENDED) ---\n' + ai.bioRewriteLong + '\n';
  }
  if (ai.elevatorPitchClean) {
    plan += '\n--- YOUR ELEVATOR PITCH ---\n' + ai.elevatorPitchClean + '\n';
  }

  if (ai.dreamClientStrategy) {
    plan += '\n--- DREAM CLIENT STRATEGY ---\n' + ai.dreamClientStrategy + '\n';
  }

  plan += '\n--- THE ONE SHIFT ---\n' + arch.shift + '\n';
  plan += '\n--- YOUR ACTION STEP ---\n' + arch.action + '\n';

  if (ai.thirtyDayPlan) {
    plan += '\n--- 30-DAY PLAN ---\n' + ai.thirtyDayPlan + '\n';
  }
  if (ai.sixtyDayMilestone) {
    plan += '\n--- 60-DAY MILESTONE ---\n' + ai.sixtyDayMilestone + '\n';
  }
  if (ai.ninetyDayVision) {
    plan += '\n--- 90-DAY VISION ---\n' + ai.ninetyDayVision + '\n';
  }

  if (ai.dmScript) {
    plan += '\n--- DM SCRIPT ---\n' + ai.dmScript + '\n';
  }
  if (ai.contentHook) {
    plan += '\n--- CONTENT HOOKS ---\n' + ai.contentHook + '\n';
  }

  if (goalData) {
    plan += '\n--- WHERE THIS LEADS ---\n' + goalData.future + '\n';
  }
  plan += '\n--- YOUR ROADMAP ---\n';
  arch.roadmapSteps.forEach(function(s, i) {
    plan += 'Step ' + (i + 1) + ': ' + s.title + '\n' + s.body + '\n\n';
  });
  plan += '\n(c) 2026 Stolan Acres | stolanacres.com\n';

  navigator.clipboard.writeText(plan).then(function() {
    var btn = document.getElementById('copy-btn');
    var orig = btn.textContent;
    btn.textContent = 'Copied!';
    btn.style.background = 'var(--olive)';
    btn.style.color = '#fff';
    setTimeout(function() { btn.textContent = orig; btn.style.background = ''; btn.style.color = ''; }, 2500);
  }).catch(function() {
    var ta = document.createElement('textarea');
    ta.value = plan;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    var btn = document.getElementById('copy-btn');
    btn.textContent = 'Copied!';
    setTimeout(function() { btn.textContent = 'Copy Action Plan'; }, 2500);
  });
}

// ---- KICK OFF ----
// Shopify loads theme assets with defer, so DOMContentLoaded
// may have already fired by the time this script runs.
// Expose functions to global scope for onclick handlers
window.copyToClip = copyToClip;
window.copyRoadmap = copyRoadmap;
window.copyActionPlan = copyActionPlan;
window.exportPDF = exportPDF;
window.rosAddToCart = typeof rosAddToCart === 'function' ? rosAddToCart : function(){};

// Wire export buttons (onclick attrs stripped by Shopify TinyMCE)
function wireExportButtons() {
  var pdfBtn = document.getElementById('pdf-btn');
  var copyBtn = document.getElementById('copy-btn');
  if (pdfBtn && !pdfBtn.onclick) pdfBtn.onclick = function(){ exportPDF(); };
  if (copyBtn && !copyBtn.onclick) copyBtn.onclick = function(){ copyActionPlan(); };
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function(){ init(); wireExportButtons(); });
} else {
  init();
  wireExportButtons();
}

})();